import BaseOnboardingService from "./baseOnboarding.service";

class TypeDemissionService extends BaseOnboardingService {
  constructor() {
    super("type-demission");
  }
}

export default new TypeDemissionService();
